import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button'; // Assurez-vous que le chemin d'importation de Button est correct
import gsap from 'gsap';

// Contextes
import { useGame } from '../utils/GameContexte';

interface BackToModesButtonProps {
    pageSelector?: string; // Rendre le sélecteur de page optionnel
    scene?: string;
    children: React.ReactNode;
}

const BackToModesButton: React.FC<BackToModesButtonProps> = ({
    pageSelector = '.container',
    scene,
    children,
}) => {
    const navigate = useNavigate();
    const { setGameFinished } = useGame();
    useEffect(() => {
        setGameFinished(false);
    }, [setGameFinished]);

    const handleBackClick = () => {
        const bannerEl = document.querySelector('.banner');
        const pageEl = document.querySelector(pageSelector);
        const logoNav = document.querySelector('.nav__logo');
        const navEl = document.querySelector('.nav');

        if (bannerEl && pageEl && logoNav && navEl) {
            const tl = gsap.timeline({
                onComplete: () => navigate('/accueil'),
            });

            tl.to(pageEl, {
                xPercent: 100,
                opacity: 0,
                duration: 0.5,
                ease: 'power1.in',
            })
                .to(bannerEl, { scaleY: 0, duration: 0.5, ease: 'power1.out' }, '<')
                .to(logoNav, { x: 0, y: 0, scale: 1, duration: 0.5, ease: 'power1.out' }, '<')
                .to(navEl, { height: '270px', duration: 0.5, ease: 'power1.out' }, '<');
        }
    };

    return (
        <Button
            scene={`${scene ? scene : 'menu'}`}
            colorName='blue'
            isSelected={false}
            onClick={handleBackClick}
        >
            {children}
        </Button>
    );
};

export default BackToModesButton;
